import React from 'react'

function ChevronDownIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={16}
      height={16}
      fill="none"
      {...props}
    >
      <path
        fill="currentColor"
        d="M7.987 10a.662.662 0 0 1-.471-.193L4.862 7.15a.667.667 0 0 1 .942-.944l2.183 2.2 2.19-2.185a.663.663 0 0 1 1.085.745.664.664 0 0 1-.17.212L8.438 9.814a.663.663 0 0 1-.451.186Z"
      />
    </svg>
  )
}

export default ChevronDownIcon
